import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slices/authSlice';
import { toggleDarkMode } from '../../redux/slices/themeSlice';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';


const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const darkMode = useSelector(state => state.theme.darkMode);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div className={`navbar ${darkMode ? 'dark' : ''}`}>
      <h2>SportsDuniya Dashboard</h2>
      <div>
        <Button variant="contained" style={{ marginLeft: 10, color: 'white', color: 'black', background: 'white'}} onClick={() => dispatch(toggleDarkMode())}>
          {darkMode ? 'Light Mode' : 'Dark Mode'}
        </Button>
        <Button variant="contained" onClick={handleLogout} style={{ marginLeft: 10, color: 'black', background: 'white'}}>
          Logout
        </Button>
      </div>
    </div>
  );
};

export default Navbar;
